import Reviews from "../reviews/UserReviews";
import classes from "./HostingPortal.module.scss";
import banner from "../../assets/imgs/hosting-banner.jpg";
import { trackEvent } from "../../utils/analytics";

const INFO_EMAIL = "info@have-adream.com";

export const HostingOrganizationPortal = () => {
  const subject = encodeURIComponent(
    "Hosting Organization Partnership — Inquiry"
  );
  const body = encodeURIComponent(
    `Hi team,
    We'd like to discuss hosting/partnership opportunities.
    — Your Name
    Organization: 
    Website: 
    Phone: `
  );

  return (
    <div style={{ background: "#f5f5f5" }}>
      <main className={`${classes.portal}`} id="main-content">
        <section
          className={`${classes.banner}`}
          role="img"
          aria-label="Coastal destination with sunrise over the sea"
        />

        <section className={`${classes.split}`} aria-label="Program overview">
          <div className={`${classes.copy}`}>
            <header
              className={`${classes.header}`}
              aria-labelledby="hosting-title"
            >
              <h2 id="hosting-title" className={`${classes.title}`}>
                Hosting Organization
              </h2>
            </header>
            <h2 className={`${classes.h2}`}>Why host with us</h2>
            <p className={`${classes.lead}`}>
              The ESC Hosting Program at Have A Dream gives international
              volunteers the chance to actively contribute to different projects
              in youth empowerment, community development, and cultural
              exchange. Volunteers join different teams within the organization
              such as project management, social media, marketing, and community
              engagement, gaining hands-on experience while supporting EU
              initiatives, local volunteering, and intercultural activities.
              Beyond daily tasks, the program offers a rich immersion in
              Egyptian culture, opportunities for personal growth, and a
              supportive environment that encourages learning from diverse
              responsibilities.
            </p>

            <div className={`${classes.ctaRow}`}>
              <a
                className={`${classes.btn} ${classes.primary}`}
                href={`mailto:${INFO_EMAIL}?subject=${subject}&body=${body}`}
                data-umami-event="Hosting Portal CTA"
                onClick={() =>
                  trackEvent({
                    event: "hosting_contact_click",
                    facebookEvent: "Lead",
                    payload: {
                      content_name: "Hosting organization partnership",
                      content_category: "Hosting",
                      contact_channel: "email",
                    },
                  })
                }
              >
                Contact us
              </a>
            </div>
          </div>
        </section>
      </main>
      <header
        style={{ textAlign: "center" }}
        className={`${classes.header}`}
        aria-labelledby="hosting-title"
      >
        <h2 id="hosting-title" className={`${classes.title}`}>
          What Volunteers Are Saying?
        </h2>
      </header>
      <Reviews isHosting={true} />
    </div>
  );
};

export default HostingOrganizationPortal;
